<template>
  <div id="scoreLine">
    <template v-if="$route.name === 'scoreLine'">
        <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
        <div class="mainCon setInfoCss" v-if="batchSetId ? true : false">
            <div class="tablePlanCss"><span style="font-weight: 600;">考试批次：</span>{{ planName }}</div>
            <el-table :data="setInfoData" border >
                <el-table-column label="课程类别" prop="groupName" width="220"></el-table-column>
                <el-table-column label="分控线(%)" prop="groupScore" width="200"></el-table-column>
                <el-table-column label="所选课程" prop="groupCourse"></el-table-column>
            </el-table>
            <!-- <div class="tableBtnCss"><el-button type="primary" @click="goSearch(batchSetId)" round>查询</el-button></div> -->
        </div>
        <div class="mainCon setTableCss">
            <el-table :data="tableData">
                <el-table-column :prop="item.prop" :label="item.label" v-for="(item,index) in thBeginList" :key="index"></el-table-column>
                <el-table-column :label="item.label" v-for="(item,index) in thMiddleList" :key="index+999" :class-name="index % 2 === 0 ? 'group-even' : 'group-odd'">
                    <el-table-column :prop="childrenItem.prop" :label="childrenItem.label" v-for="(childrenItem,childrenIndex) in item.children" :key="childrenIndex" :class-name="index % 2 === 0 ? 'group-even' : 'group-odd'"></el-table-column>
                </el-table-column>
                <el-table-column :prop="item.prop" :label="item.label" v-for="(item,index) in thEndList" :key="index+9999">
                    <template slot-scope="scope">
                      <div v-if="item.isBtn" @click="goDetail(scope.row)" class="goDetailCss">{{ scope.row[item.prop] }}</div>
                      <div v-else>{{ scope.row[item.prop] }}</div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </template>
    <template v-else>
        <router-view></router-view>
    </template>
  </div>
</template>

<script>
import { getScoreLineFn,getScoreLineCountFn,exportScoreLineCountFn } from "@/http/modules/examSet/score";

export default {
  name: "scoreLine",
  data () {
    return {
        planId: '',
        planName: '',
        setInfoData: [],
        thBeginList: [
            { label: "专业", prop: "subjectName" },
            { label: "应考人数", prop: "shouldExam" },
        ],
        thMiddleList: [
            {
                label: "学位外语课程",
                children:[
                    {
                        label: "免试人数",
                        prop: "exemptExam4A",
                    },
                    {
                        label: "达到专业分控线人数",
                        prop: "otherPass4A",
                    },
                    {
                        label: "报考人数",
                        prop: "signExam4A",
                    },
                    {
                        label: "实考人数",
                        prop: "examed4A",
                    },
                    {
                        label: "50%分控线",
                        prop: "lineScore4A",
                    },
                    {
                        label: "分控线上实际人数",
                        prop: "linePass4A",
                    },
                ]
            },
            {
                label: "学位专业综合课程",
                children:[
                    {
                        label: "免试人数",
                        prop: "exemptExam4B",
                    },
                    {
                        label: "达到英语分控线人数",
                        prop: "otherPass4B",
                    },
                    {
                        label: "报考人数",
                        prop: "signExam4B",
                    },
                    {
                        label: "实考人数",
                        prop: "examed4B",
                    },
                    {
                        label: "50%分控线",
                        prop: "lineScore4B",
                    },
                    {
                        label: "分控线上实际人数",
                        prop: "linePass4B",
                    },
                ]
            },
        ],
        thEndList: [
            { label: "参加两类课程考试人数", prop: "bothExamed" },
            { label: "达到分控线总人数", prop: "bothPass" },
            { label: "合格总人数", prop: "totalPass", isBtn: true },
            { label: "实考总人数", prop: "totalExamed" },
            { label: "学位率", prop: "passPercentName" },
        ],
        mainTopBtnList: [
            {
                title: "设置课程属性及分控线",
                fn: this.jumpNextPage,
            },
            {
                title: "导出",
                fn: this.exportInfo,
            },
        ],
        tableData: [],
    }
  },
  computed: {
    batchSetId(){
      return this.$route.query.id || '';
    },
  },
  watch: {
    'batchSetId': {
      immediate: true,
      handler(newVal) {
        this.tableData = [];
        if (newVal && this.$route.name == 'scoreLine') {
          this.getSetInfo(newVal);
        }
      }
    }
  },
  methods: {
    getSetInfo(id){
      this.setInfoData = [];
      getScoreLineFn({ batchSetId: id }).then(res => {
        if(res.code == 1){
          this.planId = res.data.planId;
          this.planName = res.data.planName;
          this.setInfoData.push({
            groupName: res.data.groupName4A,
            groupScore: res.data.groupValue4A,
            groupCourse: res.data.courseNames4A.join('、'),
          })
          this.setInfoData.push({
            groupName: res.data.groupName4B,
            groupScore: res.data.groupValue4B,
            groupCourse: res.data.courseNames4B.join('、'),
          })
          this.goSearch(id);
        }
      })
    },
    goSearch(val){
      getScoreLineCountFn({ batchSetId: val }).then(res => {
        if(res.code == 1){
          this.tableData = res.data;
          this.thMiddleList[0].label = this.setInfoData[0].groupName;
          this.thMiddleList[0].children[4].label = this.setInfoData[0].groupScore + '%分控线';
          this.thMiddleList[1].label = this.setInfoData[1].groupName;
          this.thMiddleList[1].children[4].label = this.setInfoData[1].groupScore + '%分控线';
        }else{
          this.tableData = [];
        }
      })
    },
    jumpNextPage() {
      this.$router.push({
        name: "scoreLineSet"
      })
    },
    exportInfo(){
      let val = this.batchSetId || '';
      if(val == ''){
        this.$message.warning('请先设置课程属性及分控线');
        return;
      }else{
        exportScoreLineCountFn({ batchSetId: val }).then(res => {
          if(res.code == 1){
            window.open(res.data, '_blank');
          }
        })
      }
    },
    goDetail(row){
      if(row.totalPass == 0){
        this.$message.warning('该专业暂无数据');
        return;
      }
      this.$router.push({
        name: "scoreLineDetail",
        query: {
          id: row.id,
          pId: this.planId,
          bId: row.batchSetId,
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-table th > .cell {
  text-align: center;
}
/deep/ .el-table td > .cell {
  text-align: center;
}
.setInfoCss{
  /deep/ .el-table th > .cell {
    text-align: center;
  }
  /deep/ .el-table td > .cell {
    text-align: center;
  }
  /deep/ .el-table th:nth-child(3) .cell {
    padding-left: 20px;
    text-align: left;
  }
  /deep/ .el-table td:nth-child(3) .cell {
    padding-left: 20px;
    text-align: left;
  }
}
.setTableCss{
  /deep/ .el-table td:nth-child(7) .cell {
    color:#F56C6C;
  }
  /deep/ .el-table td:nth-child(13) .cell {
    color:#F56C6C;
  }
  /deep/ .el-table .group-even {
    background-color: #f0f7ff !important;
  }
  /deep/ .el-table .group-odd {
    background-color: #fdf6ec !important;
  }
  /deep/ .el-table__body tr:hover > td.group-even {
    background-color: #e6f0fa !important;
  }
  /deep/ .el-table__body tr:hover > td.group-odd {
    background-color: #f5edd8 !important;
  }
}
.goDetailCss{
  color: #006AFF;
  cursor: pointer;
}
.tablePlanCss{
    padding: 0px 0px 10px 3px;
    font{
        font-weight: bold;
    }
}
.tableBtnCss{
    margin-top: 10px;
    text-align: center;
}
</style>